export default "__VITE_ASSET__b83a0bc8__"